<template>
  <v-container>
    <v-row>
      <v-col>
        <h3>POI name:</h3>
        <div>{{ poiRel.poi?.name }}</div>
        <h3>Status: <status-icon :status="poiRel.status" :count-video="poiRel.videos?.length"></status-icon></h3>
      </v-col>
      <v-col>
        <v-dialog
          v-model="poiMarkersDialog.show"
          max-width="80%"
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              small
            >
              Google map
            </v-btn>
          </template>
          <v-card>
            <v-card-title></v-card-title>
            <v-card-text v-if="poiRel.id">
              <GoogleMapMarkers
                ref="poiMapMarkers"
                :items="[poiRel.poi]"
                :isVisible="true"
              />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="poiMarkersDialog.show=false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
      <v-tab>Videos</v-tab>
      <v-tab
        @click="bulkSetCommentRead"
      >
        <v-badge
          dot
          color="green"
          :value="newComments.length"
        >Comments</v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item class="pa-1">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col>
                <div class="ma-3" v-if="poiRel.status === $constants.POI_STATUSES.NEW">
                  <v-btn class="ma-2" color="primary"
                         fab small
                         @click="() => this.$refs.fileInput.$refs.input.click()"
                  >
                    <v-icon large>mdi-plus</v-icon>
                  </v-btn>
                  <v-file-input
                    class="d-none"
                    v-model="videoInput"
                    multiple
                    hide-input
                    accept="video/*"
                    @change="addVideoFromFile()"
                    ref="fileInput"
                  ></v-file-input>
                  Please make sure the resolution of your video content is not lower than: 1920x1080
                </div>
              </v-col>
            </v-row>

            <v-divider class="my-3"></v-divider>

            <v-row>
              <v-col
                v-for="video in poiRel.videos"
                :key="video.id"
                cols="6"
                sm="4"
                md="3"
              >
                <video-card
                  :video="video"
                  @deleteVideo="deleteVideo"
                  :deletable="poiRel.status === $constants.POI_STATUSES.NEW"
                >
                  <div v-if="video.status === $constants.VIDEO_STATUSES.REJECTED">
                    <div class="shadow-box"></div>

                    <div class="upload-button red">
                      Rejected
                    </div>
                  </div>
                  <div v-if="video.status === $constants.VIDEO_STATUSES.ACCEPTED || video.status === $constants.VIDEO_STATUSES.ARCHIVE">
                    <div class="upload-button green">
                      Accepted
                    </div>
                  </div>
                </video-card>
              </v-col>
              <v-col
                v-for="video in uploadingVideo"
                :key="video.name"
                cols="6"
                sm="4"
                md="3"
              >
                <v-card
                  :width="200"
                  class="overflow-hidden card-video"
                >
                  <v-container class="uploading-status grey lighten-2">
                    <v-row
                      class="fill-height"
                      align-content="center"
                      justify="center"
                    >
                      <v-col class="text-center" cols="12">
                        Uploading video
                      </v-col>
                      <v-col class="text-center text-truncate" cols="12">
                        {{ video.name }}
                      </v-col>
                      <v-col cols="10">
                        <v-progress-linear
                          v-model="video.progress"
                          height="25"
                        >
                          <strong>{{ video.progress }}%</strong>
                        </v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <div class="d-flex flex-wrap align-start mb-6">

            </div>
            <div
              v-if="poiRel.status === $constants.POI_STATUSES.NEW"
              class="text-center"
            >
              <v-btn
                class="mb-2"
                color="green"
                @click="setInReviewStatus"
                v-if="poiRel.videos?.length > 0"
                :disabled="countReadyVideo() < 3"
              >
                Submit
              </v-btn>
              <div v-if="countReadyVideo() < 3">
                <div class="black--text">Please upload minimum 3 videos to submit for review.</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item class="pa-1">
        <v-card>
          <v-card-text>
            <div
              v-for="video in poiRel.videos"
              :key="video.id"
            >
              <v-row
                v-if="video.comment"
                :class="!video.comment_read ? 'green lighten-2' : ''"
              >
                <v-col cols="4" sm="2">
                  <video-card
                    :video="video"
                    :playable="false"
                  >
                  </video-card>
                </v-col>
                <v-col class="pa-5 align-self-center">{{video.comment}}</v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="afterSubmitDialog"
      width="initial"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="text-center">
          <div style="opacity: 0.5;padding-left: 15px;">
            <logo-block :small="true"></logo-block>
          </div>
          <h3>Thank you for your work!</h3>
          <h3>The TripBits Team will give you feedback soon.</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="afterSubmitDialog=false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoogleMapMarkers from '../components/GoogleMapMarkers.vue';
import VideoCard from '../components/VideoCard.vue';
import StatusIcon from "@/components/StatusIcon";
import LogoBlock from "@/components/LogoBlock.vue";

export default {
  name: 'MyPoiView',
  components: {
    LogoBlock,
    StatusIcon,
    GoogleMapMarkers,
    VideoCard,
  },
  mounted() {
    this.getPoi()
    this.listenUpdateVideo()
  },
  data() {
    return {
      poiRel: {},
      uploadingVideo : [],
      newComments: [],
      poiMarkersDialog: {
        show: false
      },
      videoInput: null,
      tab: null,
      afterSubmitDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      userId: 'auth/userId',
    }),
  },

  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),

    listenUpdateVideo() {
      this.$websocket.Echo().private('AmbVideoUpdate')
        .listen(`.update-amb-video-${this.userId}`, (event) => {
          if (event.ambVideo) {
            const index = this.poiRel.videos.findIndex((e) => e.id === event.ambVideo.id);
            if (index > -1) {
              Object.assign(this.poiRel.videos[index], event.ambVideo);
            }
          }
        })
    },

    getPoi() {
      this.$requestHelpers.get('/api/ambassador/poi/' + this.$route.params.id)
        .then((data) => {
          if (Array.isArray(data) && data.length === 0) {
            this.$router.push({name: 'home'})
          } else {
            this.poiRel = data
            this.newComments = data.videos.filter((e) => e.comment && !e.comment_read);
          }
        })
    },

    bulkSetCommentRead() {
      this.newComments.map((video) => {
        this.setCommentRead(video)
      })
    },

    setCommentRead(video) {
      if (!video.comment_read) {
        this.$requestHelpers.post('/api/ambassador/video/setCommentRead/' + video.id, {})
          .then(() => {
          })
      }
    },

    async addVideoFromFile() {
      for (let i in this.videoInput) {
        await this.uploadVideo(this.videoInput[i])
      }
      this.$refs.fileInput.$refs.input.value = null
      this.videoInput = null
    },

    deleteVideo(videoId) {
      this.$requestHelpers.delete('/api/ambassador/video/delete/' + videoId, {})
        .then(() => {
          this.getPoi()
        })
    },

    uploadVideo(file) {
      if (!this.poiRel.poi) {
        return
      }

      // check resolution
      const url = URL.createObjectURL(file);
      const video = document.createElement("video");
      video.addEventListener("loadedmetadata", (event) => {
        const formData = new FormData();
        formData.append('id', this.$route.params.id);

        if (event.target.videoWidth === 0) {
          formData.append('need-check-resolution', true);
        }

        if (event.target.videoWidth > 0) {
          const maxSize = Math.max(event.target.videoWidth, event.target.videoHeight)
          if (maxSize < 1920) {
            this.showSnack({
              text: 'Please make sure the resolution of your video content is not lower than:<br/>' +
                '1920x1080',
              color: 'error',
              timeout: 10000,
            })
            return
          }
        }

        if (event.target.duration > 0) {
          formData.append('duration', parseInt(event.target.duration));
        }

        formData.append('video_file', file)

        const progress = { name: file.name, progress: 0 };
        this.uploadingVideo.push(progress);

        this.$requestHelpers.post('/api/ambassador/video/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const done = progressEvent.loaded;
            const totalProgress = progressEvent.total;

            progress.progress = this.percentProgress(done, totalProgress);
          },
        }).then(() => {
          this.getPoi()
        }).finally(() => {
          this.uploadingVideo = this.uploadingVideo.filter((e) => e.name !== progress.name);
        })
      });
      video.src = url;
    },

    percentProgress(done, total) {
      if (!total) {
        return 0;
      }

      const progress = Math.round((done / total) * 100);
      return parseInt(progress, 10);
    },

    countReadyVideo()
    {
      return this.poiRel.videos.filter((e) => e.status !== this.$constants.VIDEO_STATUSES.ERROR && e.preview_url).length
    },

    setInReviewStatus() {
      if (this.countReadyVideo() < 3) {
        return
      }

      this.$confirm('After submitting you will not be able to add more video content. Are you sure you want to continue?').then((res) => {
        if (!res) return;

        this.$requestHelpers.post('/api/ambassador/poi/set-in-review-status/' + this.$route.params.id, {})
          .then(() => {
            this.afterSubmitDialog = true
          })
      })
    },
  },
  watch:{
    afterSubmitDialog: function(newValue){
      if (!newValue){
        this.$router.push({name: 'home'})
      }
    }
  },

  destroyed() {
    this.$websocket.Echo().private('AmbVideoUpdate')
      .stopListening(`.update-amb-video-${this.userId}`);
  },
}
</script>

<style scoped>
.upload-button {
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-weight: 500;
  padding: 7px 0;
}
.shadow-box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(204 204 204 / 71%);
  bottom: 0;
  right: 0;
}
.uploading-status {
  height: 200px;
}
</style>
